export default __webpack_public_path__ + "static/media/faq.064215a7.svg";